import { Component, Input, ViewEncapsulation, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { GoogleData } from '../../services/GoogleData/GoogleData';
import { StateService } from '@uirouter/angular';
import Quagga from 'quagga';

@Component({
    selector: 'barcodeScanner',
    templateUrl: './barcode-scanner.html',
    styleUrls: ['./barcode-scanner.css', './barcode-scanner.mobile.css'],
    encapsulation: ViewEncapsulation.None
})

export class BarcodeScannerComponent implements OnInit, OnDestroy {
    @ViewChild('barcodeTarget') barcodeTarget:ElementRef;
    showSpinner:boolean = false;
    dimVideo:boolean = false;

    constructor(private googleData:GoogleData, private stateService:StateService) {
        this.stateService.current.onReactivate = this.onReactivated.bind(this);
    }

    onReactivated() {
        this.showSpinner = false;
        this.dimVideo = false;
        this.initialiseQuagga();
    }

    async onDetected(data) {
        var isbn = data.codeResult.code;

        if (this.googleData.isValidISBN(isbn)) {
            console.log(`Found barcode ${isbn}`);
            
            Quagga.stop();
            Quagga.offDetected(this.onDetected);
            
            this.showSpinner = true;
            this.dimVideo = true;
            navigator.vibrate(200);
            
            var googleId = await this.googleData.getGoogleIdFromISBN(isbn);
            await this.stateService.go('book', {googleId: googleId, fromScan: true});
            this.showSpinner = false;
        } else {
            console.log(`Invalid ISBN ${isbn}`);
        }
    }
    
    initialiseQuagga() {
        var onDetected = this.onDetected.bind(this);
        Quagga.init({
            inputStream : {
              name : "Live",
              type : "LiveStream",
              target: this.barcodeTarget.nativeElement
            },
            decoder : {
              readers : ["ean_reader"]
            }
          }, function(err) {
              if (err) {
                  console.log(err);
                  return
              }
              console.log("Initialization finished. Ready to start");
              Quagga.onDetected(onDetected);
              Quagga.start();
        });
    }

    ngOnInit() {
        this.initialiseQuagga();
    }

    ngOnDestroy() {
        Quagga.offDetected(this.onDetected);
        Quagga.stop();
    }

    
}



// WEBPACK FOOTER //
// ./web/static/components/barcode-scanner/barcode-scanner.ts